import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PasswordValidation } from '../../../services/match';
import { RutValidator } from 'ng9-rut';
import { UserService } from './../../../services/user.service';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { GLOBAL } from '../../../services/global';

@Component({
  selector: 'app-forgot-pass',
  templateUrl: './forgot-pass.component.html',
  styleUrls: ['./forgot-pass.component.css']
})

export class ForgotPassComponent implements OnInit {

  @ViewChild('passNoResp') passNoResp: TemplateRef<any>;
  @ViewChild('passResp') passResp: TemplateRef<any>;

  public nombreMuni = GLOBAL.nombreMuni;
  public contrasenas;
  hide2 = true;
  hide3 = true;
  rut

  constructor(
    private fb: FormBuilder,
    rutValidator: RutValidator,
    private _userService: UserService,
    public dialog: MatDialog,
    private _router: Router,
    private route : ActivatedRoute,
    private spinner : NgxSpinnerService
  ) {
    this.contrasenas = this.fb.group({
      contrasena: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(15)]],
      repContrasena: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(15)]]
    }, {
      validator: PasswordValidation.MatchPassword
    })
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe(queryParams => {
      // this.userType = queryParams.get("userType");
      console.log(queryParams)
      this.rut = queryParams.get("rut");
   })
    console.log(this.rut)
  }

  restablecer() {
    console.log(this.contrasenas)
    this.spinner.show()
    this._userService.resetPass(this.rut, this.contrasenas.value.repContrasena).subscribe(resp => {

      if (resp.status == 'ok') {
        this.dialog.open(this.passResp);
        // this._router.navigate([`/`]);
        this.spinner.hide()
      } else {
        this.dialog.open(this.passNoResp);
        this.spinner.hide()
      }


    })
  }

  redirect() {
    this._router.navigate([`/`]);
    this.dialog.closeAll()
  }

}
